<script lang="ts" setup>
  import { MyAccountRoute } from "@/constants/routes/myAccount"
  import Link from "@/components/ui/link/Link.vue"
</script>
<template>
  <h4>We're sorry you've not been happy with our service.</h4>
  <p>
    We provide electricity and gas to a wide variety of customers, and we
    recognise that each one is unique. You may be eligible for additional
    support if you are a vulnerable customer. Our
    <Link :to="MyAccountRoute.psr" class="link text-primary-600">
      Priority Services Register (PSR)
    </Link>
    is a free, confidential service that gives our vulnerable customers extra
    advice and support.
  </p>
  <p>This is for you if:</p>
  <ul class="list-disc pl-7">
    <li>Are aged 60 or over</li>
    <li>Are pregnant or live with a child under the age of 5</li>
    <li>Live in a household where everyone is under 18 years old</li>
    <li>
      Have a physical or mental disability or a long-term health condition
    </li>
    <li>
      Are blind or partially sighted, deaf or hard of hearing, or you have a
      poor sense of smell
    </li>
    <li>Rely on electricity, gas, or water for health reasons</li>
    <li>Had a recent life-changing event such as a bereavement or job loss</li>
    <li>Need other additional support from us</li>
  </ul>
</template>
